import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { toast } from "sonner";

const PROD_STATUSES = ["PENDING","SENT_TO_PRODUCTION","IN_PRODUCTION","COMPLETED"];

export default function AdminProduction() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/production").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);
  const setStatus = async (id, s) => { await api.patch(`/admin/orders/${id}`, { production_status: s }); toast.success("OK"); load(); };
  const exportCsv = async () => {
    const token = localStorage.getItem("admin_token");
    const r = await fetch(`${API}/admin/production/export`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "production_report.csv"; a.click();
  };
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="display text-4xl md:text-6xl">PRODUCTION QUEUE</h1>
        <button data-testid="export-csv-btn" onClick={exportCsv} className="bg-white text-black px-6 py-3 text-xs tracking-widest">EXPORT CSV</button>
      </div>
      {orders.length === 0 ? <div className="text-neutral-500">Belum ada order berbayar.</div> : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-[color:var(--border)] p-4">
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                  <div className="text-[10px] text-neutral-500 tracking-widest">ORDER</div>
                  <div className="display text-2xl">{o.order_number}</div>
                </div>
                <select data-testid={`prod-${o.order_number}`} value={o.production_status} onChange={(e) => setStatus(o.id, e.target.value)} className="bg-transparent border border-[color:var(--border)] p-2 text-xs">
                  {PROD_STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div className="grid md:grid-cols-2 gap-2 mt-3 text-xs">
                {o.items.map((it, i) => (
                  <div key={i} className="border border-[color:var(--border)] p-2">
                    <div className="mono">{it.article_code}</div>
                    <div>{it.name}</div>
                    <div className="text-neutral-500">{it.color} · {it.size} × {it.qty}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
